var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-tab",attrs:{"data-cy":"action-substitution-tab"}},[_c('substitutions',{attrs:{"substitutions":_vm.substitutions},on:{"updated:substitution":_vm.updatedSubstitution}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }